import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IClaimInfoResponseDto, ICreateClaimAggregatorDtoSourceEnum } from '@/dtos';

export type CreatedHsaWithdrawalClaimDto = IClaimInfoResponseDto;

export interface CreateHsaWithdrawalClaimDto {
  amount?: string;
  accountId?: string;
  notes?: string;
  documentId?: string;
  paymentMethodId?: string;
}

const useCreateHsaWithdrawalClaimQuery = () => {
  const { mutateAsync, isLoading } = useMutation((hsaWithdrawalClaim: CreateHsaWithdrawalClaimDto) =>
    api.post<CreatedHsaWithdrawalClaimDto>(API_URL.CLAIMS_HSA_WITHDRAWALS, {
      account_id: hsaWithdrawalClaim?.accountId,
      amount: hsaWithdrawalClaim?.amount,
      ...hsaWithdrawalClaim?.notes ? { employee_notes: hsaWithdrawalClaim?.notes } : {},
      payment_method_id: hsaWithdrawalClaim?.paymentMethodId,
      document_id: hsaWithdrawalClaim?.documentId,
      source: ICreateClaimAggregatorDtoSourceEnum.WEBSITE,
    })
  );

  const createHsaWithdrawalClaim = useCallback(
    async (hsaWithdrawalClaim: CreateHsaWithdrawalClaimDto): Promise<CreatedHsaWithdrawalClaimDto> => {
      const response = await mutateAsync(hsaWithdrawalClaim);
      return response.data;
    },
    [mutateAsync]
  );

  return {
    createHsaWithdrawalClaim,
    isCreateHsaWithdrawalClaimLoading: isLoading,
  };
};

export default useCreateHsaWithdrawalClaimQuery;
